module.exports = __webpack_public_path__ + "znamenka-a-kozni-vyrustky_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/znamenka-a-kozni-vyrustky_2_after_tn.jpg
// module id = 1475
// module chunks = 0